import { render, staticRenderFns } from "./IntegralChangeList.vue?vue&type=template&id=b81664a4&scoped=true"
import script from "./IntegralChangeList.vue?vue&type=script&lang=js"
export * from "./IntegralChangeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81664a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b81664a4')) {
      api.createRecord('b81664a4', component.options)
    } else {
      api.reload('b81664a4', component.options)
    }
    module.hot.accept("./IntegralChangeList.vue?vue&type=template&id=b81664a4&scoped=true", function () {
      api.rerender('b81664a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/user/IntegralChangeList.vue"
export default component.exports